var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0985 93.8244C73.0075 93.8244 93.9691 72.8211 93.9177 46.9122C93.8663 21.0033 72.8213 0 46.9123 0C21.0034 0 0.0416817 21.0033 0.0930987 46.9122C0.144516 72.8211 21.1896 93.8244 47.0985 93.8244Z",
    fill: "url(#paint0_linear_365_9990)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 46.7502C6.03516 24.09 24.4679 5.65723 47.1282 5.65723C69.7884 5.65723 88.2211 24.09 88.2211 46.7502C88.2211 69.4104 69.7884 87.8432 47.1282 87.8432C24.4679 87.8432 6.03516 69.4104 6.03516 46.7502Z",
    fill: "#1EBBD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.868 55.01C61.5913 53.6791 60.5793 52.6411 59.2833 52.326L52.8762 50.7728C52.2209 50.6096 51.7476 51.3993 52.1845 51.922L53.4805 53.5049L50.0657 61.9645L47.2408 57.0563C47.117 56.8413 46.8149 56.8413 46.6911 57.0563L43.8588 61.9645L40.4514 53.5049L41.7474 51.922C42.1733 51.3993 41.6964 50.6096 41.0448 50.7728L34.6376 52.326C33.3417 52.6374 32.3405 53.6754 32.0529 55.01L29.876 65.2972H64.0595L61.8716 55.01H61.868Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9687 51.608C46.6317 51.608 46.2947 51.5657 45.9577 51.4775L45.3333 52.1653C45.1185 52.4052 45.0888 52.7649 45.2606 53.0365L46.6944 55.6747C46.8167 55.8969 47.1173 55.8969 47.2396 55.6747L48.6734 53.0365C48.8485 52.7649 48.8155 52.4052 48.6007 52.1653L47.9763 51.4775C47.6393 51.5657 47.3023 51.608 46.9653 51.608H46.9687Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8013 50.5433C46.559 50.8198 47.3799 50.8198 48.1376 50.5433C50.0876 49.8353 53.8761 47.8882 54.7007 43.2862C54.7007 43.2862 58.6972 38.8279 55.6255 38.3338C55.6255 38.3338 56.387 28.2041 46.9676 28.2041C37.5482 28.2041 38.3097 38.3338 38.3097 38.3338C35.238 38.8242 39.2345 43.2862 39.2345 43.2862C40.0591 47.8882 43.8476 49.8353 45.7976 50.5433H45.8013Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_365_9990",
    x1: 52.0953,
    y1: -6.08723,
    x2: 41.3967,
    y2: 103.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostumberIcon);
export default __webpack_public_path__ + "static/media/CostumberIcon.f407f53d41942494f0e30d3c52e6624b.svg";
export { ForwardRef as ReactComponent };